import { Route, Routes } from "react-router-dom";
import PrivateRoutes from "../utils/privateRoutes";
import { Index } from "../../../public/pages/index";
import { PostsFeed } from "../../../components/posts/postsFeed";
import { NotFound } from "../../../components/notFound/NotFound";
import { useIsAuthenticated } from "@azure/msal-react";
import PostView from "../../../components/posts/postView/postView";
import { CesiumViewer } from "../../../components/earthtwin/earthtwin";
import { PostEdit } from "../../../components/posts/postEdit/postEdit";
import {
  Admin,
  AdminUsers,
  AdminPosts,
  AdminSharing,
  AdminQrCode,
  AdminImportantObjFile,
  AdminMobileAsset,
  AdminFormsForm,
  AdminFormsDocuments,
  AdminFormsTeam,
  AdminFormsStructure,
} from "../../../components/admin/admin";
import { Search } from "../../../components/search/search";
import {
  Account,
  AccountProfile,
  AccountInformation,
  AccountSettings,
} from "../../../components";
import {
  Contacts,
  ContactsContacts,
  ContactsGroups,
  ContactsNotifications,
} from "../../../components/contacts";
import { ResiumMap } from "../resiumMap/resiumMap";
import { ShapeFiles } from "../../../components/admin/components/shapeFiles/shapeFiles";
import { POIFiles } from "../../../components/admin/components/POIFiles/POIFiles";
import { MatterportViewer3 } from "../../../components/matterportViewer/matterportViewer3";
import { Privacy } from "../../../components/privacy/privacy";
import { Eula } from "../../../components/eula/eula";
import { DownloadAppLinks } from "../../../components/mobileApp/downloadAppLinks";

export const Pages = () => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <Routes>
      <Route index element={isAuthenticated ? <PostsFeed /> : <Index />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="eula" element={<Eula />} />
      <Route path="app" element={<DownloadAppLinks />} />
      <Route element={<PrivateRoutes />}>
        <Route path="posts" element={<PostsFeed />} />
        <Route path="posts/:id" element={<PostView />} />
        <Route path="posts/create" element={<PostEdit />} />
        <Route path="posts/edit/:id" element={<PostEdit />} />
        <Route path="earthtwin" element={<CesiumViewer />} />
        <Route path="earthtwin2" element={<ResiumMap />} />
        <Route path="earthtwin2/bookmark/:id" element={<ResiumMap />} />
        <Route path="matterport" element={<MatterportViewer3 />} />
        <Route path="matterport/qr-code/:id" element={<MatterportViewer3 />} />
        <Route path="matterport/poi/:id" element={<MatterportViewer3 />} />
        <Route
          path="contacts"
          element={<Contacts page={<ContactsContacts />} />}
        />
        <Route
          path="contacts/groups"
          element={<Contacts page={<ContactsGroups />} />}
        />
        <Route
          path="contacts/notifications"
          element={<Contacts page={<ContactsNotifications />} />}
        />
        <Route path="search" element={<Search />} />
        <Route path="admin" element={<Admin />} />
        <Route path="admin/users" element={<Admin page={<AdminUsers />} />} />
        <Route path="admin/posts" element={<Admin page={<AdminPosts />} />} />
        <Route
          path="admin/sharing"
          element={<Admin page={<AdminSharing />} />}
        />
        <Route
          path="admin/qr-code"
          element={<Admin page={<AdminQrCode />} />}
        />
        <Route
          path="admin/shape-files"
          element={<Admin page={<ShapeFiles />} />}
        />
        <Route
          path="admin/important-obj-file"
          element={<Admin page={<AdminImportantObjFile />} />}
        />
        <Route
          path="admin/mobile-asset"
          element={<Admin page={<AdminMobileAsset />} />}
        />
        <Route
          path="admin/forms"
          element={<Admin page={<AdminFormsForm />} />}
        />
        <Route
          path="admin/forms/documents"
          element={<Admin page={<AdminFormsDocuments />} />}
        />
        <Route
          path="admin/forms/team"
          element={<Admin page={<AdminFormsTeam />} />}
        />
        <Route
          path="admin/forms/structure"
          element={<Admin page={<AdminFormsStructure />} />}
        />
        <Route
          path="account/profile"
          element={<Account page={<AccountProfile />} />}
        />
        <Route
          path="account/information"
          element={<Account page={<AccountInformation />} />}
        />
        <Route
          path="account/settings"
          element={<Account page={<AccountSettings />} />}
        />
        <Route path="admin/poi-files" element={<Admin page={<POIFiles />} />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
